var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Output, EventEmitter, Inject } from '@angular/core';
import * as _ from 'lodash';
import { GraphicsType } from '../../../../shared/helpers/graphics-type-help';
import { CreateOrEditGraphComponent } from '../create-or-edit-graph.component';
import { ConfigureComponentBase } from '../../../../../../shared/configure-component-base';
import { AppConsts } from '../../../../../../shared/AppConsts';
import { HttpClient } from '@angular/common/http';
var GalleryUserComponent = /** @class */ (function (_super) {
    __extends(GalleryUserComponent, _super);
    function GalleryUserComponent(injector, sanitizer, http, graphService, userGalleryService, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.sanitizer = sanitizer;
        _this.http = http;
        _this.graphService = graphService;
        _this.userGalleryService = userGalleryService;
        _this.modalService = modalService;
        _this.userGroups = [];
        _this.graphList = [];
        _this.currentGraphStateList = [];
        _this.selectedGraphChange = new EventEmitter();
        return _this;
    }
    GalleryUserComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userGraphAddedCallback = function (__) { _this.loadUserGroups(); };
        this.userGraphReplacedCallback = function (__) { _this.loadUserGroups(); };
        abp.event.on('userGraph:Added', this.userGraphAddedCallback);
        abp.event.on('userGraph:Replaced', this.userGraphReplacedCallback);
    };
    GalleryUserComponent.prototype.ngOnDestroy = function () {
        abp.event.off('userGraph:Added', this.userGraphAddedCallback);
        abp.event.off('userGraph:Replaced', this.userGraphReplacedCallback);
    };
    GalleryUserComponent.prototype.loadUserGroups = function (currentGraphName) {
        var _this = this;
        this.userGroups = [];
        this.userGalleryService.getUserGroups().subscribe(function (groups) {
            // eslint-disable-next-line eqeqeq
            if (groups.otherUsers.length == 0) {
                _this.currentGraph = null;
                _this.selectedGraphChange.emit(_this.currentGraph);
            }
            _.each(groups.otherUsers, function (user) {
                var item = {
                    id: user.id,
                    name: user.name + '-' + _this.lc('OtherGallery'),
                };
                _this.userGroups.push(item);
            });
            _this.userGroups.unshift({ id: groups.mineGalelryId, name: _this.lc('MineGallery') });
            if (_this.userGroups && _this.userGroups.length) {
                _this.changeGroup(_this.userGroups[0], currentGraphName);
            }
        });
    };
    GalleryUserComponent.prototype.changeGroup = function (group, currentGraphName) {
        var _this = this;
        this.selectedGroup = group;
        this.userGalleryId = group.id;
        if (group.name && group.name === this.lc('MineGallery')) {
            this.isMyself = true;
        }
        else {
            this.isMyself = false;
        }
        if (!group.id) {
            this.selectedGraph = {};
            this.graphList = [];
            this.currentGraphStateList = [];
            return;
        }
        this.userGalleryService.getGraphs(group.id).subscribe(function (graphs) {
            _this.graphList = graphs.items;
            if (_this.graphList && _this.graphList.length) {
                var currentGraph = _this.graphList[0];
                if (currentGraphName) {
                    var findedGraph = _.find(graphs.items, function (graph) { return graph.name === currentGraphName; });
                    if (findedGraph) {
                        currentGraph = findedGraph;
                    }
                }
                _this.changeGraph(currentGraph);
            }
            else {
                _this.selectedGraph = undefined;
                _this.currentGraphStateList = [];
                _this.currentGraph = {};
                _this.currentGraph.graphicsType = GraphicsType.user;
                _this.currentGraph.list = _this.currentGraphStateList;
                _this.selectedGraphChange.emit(_this.currentGraph);
            }
        });
    };
    GalleryUserComponent.prototype.changeGraph = function (graph) {
        var _this = this;
        this.userGalleryService.getGraphStates(graph.id).subscribe(function (states) {
            _this.currentGraphStateList = [];
            _.each(states.items, function (state) {
                var stateGraph = {
                    id: state.id,
                    name: _this.lc('State') + state.index,
                    type: state.type
                };
                stateGraph.url = AppConsts.remoteServiceBaseUrl + state.url;
                _this.currentGraphStateList.push(stateGraph);
            });
            if (_this.currentGraphStateList.length > 0) {
                _this.currentGraphStateId = _this.currentGraphStateList[0].id;
            }
            _this.currentGraph = {};
            _this.currentGraph.list = _this.currentGraphStateList;
            _this.currentGraph.name = graph.name;
            _this.currentGraph.graphId = graph.id;
            _this.currentGraph.userGalleryId = _this.userGalleryId;
            _this.currentGraph.graphicsType = GraphicsType.user;
            _this.selectedGraphChange.emit(_this.currentGraph);
        });
        this.selectedGraph = graph;
    };
    GalleryUserComponent.prototype.createOrEditGraph = function (id) {
        var _this = this;
        var input = { id: id, userGalleryId: this.userGalleryId, isImportGraph: false, graphicsType: GraphicsType.user };
        var modalRef = this.modalService.show(CreateOrEditGraphComponent, { initialState: { parameter: input }, backdrop: 'static' });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.loadUserGroups(result.graphName);
            }
            onClosedSub.unsubscribe();
        });
    };
    GalleryUserComponent.prototype.deleteGraph = function (selectedGraph) {
        var _this = this;
        if (selectedGraph) {
            this.message.confirm(this.lc('DeleteGraphWarningMessage', selectedGraph.name), this.l('AreYouSure'), function (isConfirmed) {
                if (isConfirmed) {
                    _this.userGalleryService.deleteUserGraph(_this.userGalleryId, selectedGraph.id).subscribe(function () {
                        _this.loadUserGroups();
                    });
                }
            });
        }
    };
    __decorate([
        Output()
    ], GalleryUserComponent.prototype, "selectedGraphChange", void 0);
    GalleryUserComponent = __decorate([
        Component({
            selector: 'gallery-user',
            styles: [".gallery-wrap { ul { list-style: none; padding: 0; margin: 0; } li { cursor: pointer; } a:focus, a:hover { color: #2889d0; border: none; } a:active, a:hover { outline: 0; } .listLink { display: block; text-decoration: none; color: #303030; padding: 8px 12px 8px 10px; text-overflow: ellipsis; } .listLink:hover { text-decoration: none; background: #EEEEEE; } .listLinkSelected { display: block; text-decoration: none; padding: 8px 12px 8px 10px; background: #EEEEEE; border: 1px solid #EEEEEE; } a { color: #EEEEEE; text-decoration: none; } .graphSettingBox { height: 255px; border: 1px solid #ddd; overflow-x: auto; display: block; .font12Size { font-size: 12px; } .selectedType { background: #EEEEEE; } } .graphType { width: 140px; float: left; height: 400px; margin-right: 10px; } .graphBoxes { width: 78%; } .stateBox { height: 140px; margin-top: 5px; border: none; } .colorPick { width: 50px; } .span-inline-block { display: inline-block; width: 100%; } .backgroundBorder { padding: 5px; border: 1px solid #ddd; } .graphBtns button { height: 26px; line-height: 22px; margin-right: 10px; } }",
                " .selectedGroup { display: block; text-decoration: none; background: #EEEEEE; border: 1px solid #EEEEEE; } .listLink{ position: relative; max-height: 50px; overflow: hidden; word-break: break-all; -webkit-line-clamp: 2; display: -webkit-box; -webkit-box-orient: vertical; } "],
            template: "<div style=\"border: 0;\" class='gallery-wrap clearfix'> <div class=\"form-group border-group clearfix\"> <div class=\"graphSettingBox graphType\"> <ul *ngFor=\"let group of userGroups\"> <li [class.selectedGroup]=\"group.id==selectedGroup.id\"> <a class=\"listLink\" tooltip=\"{{group.name}}\" (click)=\"changeGroup(group)\">{{group.name}}</a> </li> </ul> </div> <div style=\"display: flow-root;\"> <div class=\"graphSettingBox graphBox\"> <graph-list [graphList]=\"graphList\" (graphSelected)=\"changeGraph($event)\" [selectedGraphId]=\"selectedGraph?.id\"></graph-list> </div> <div class=\"graphSettingBox stateBox\"> <div>{{lc(\"State\")}}:</div> <graph-state-list [stateList]=\"currentGraphStateList\" [(selectedStateId)]=\"currentGraphStateId\"></graph-state-list> </div> </div> </div> <div class=\"graphBtns\"> <button *ngIf=\"isMyself\" type=\"button\" class=\"fe-btn-small fe-btn-operate\" (click)=\"createOrEditGraph()\">{{lc(\"CreateGraph\")}}</button> <button *ngIf=\"isMyself&&selectedGraph\" type=\"button\" class=\"fe-btn-small fe-btn-operate\" (click)=\"createOrEditGraph(selectedGraph.id)\">{{lc(\"EditGraph\")}}</button> <button *ngIf=\"isMyself\" type=\"button\" class=\"fe-btn-small fe-btn-operate\" (click)=\"deleteGraph(selectedGraph)\">{{lc(\"DeleteGraph\")}}</button> </div> </div> "
        }),
        __param(2, Inject(HttpClient))
    ], GalleryUserComponent);
    return GalleryUserComponent;
}(ConfigureComponentBase));
export { GalleryUserComponent };
